"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = SearchInput;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
function SearchIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4 text-default-400", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" }) }));
}
function SearchInput(props) {
    var _a = props.placeholder, placeholder = _a === void 0 ? "Search..." : _a, _b = props.value, value = _b === void 0 ? "" : _b, onChange = props.onChange, _c = props.debounceMs, debounceMs = _c === void 0 ? 300 : _c, className = props.className;
    var _d = (0, react_2.useState)(value), localValue = _d[0], setLocalValue = _d[1];
    // Update local value when prop value changes
    (0, react_2.useEffect)(function () {
        setLocalValue(value);
    }, [value]);
    // Debounce the onChange callback
    (0, react_2.useEffect)(function () {
        var timer = setTimeout(function () {
            if (localValue !== value) {
                onChange(localValue);
            }
        }, debounceMs);
        return function () { return clearTimeout(timer); };
    }, [localValue, debounceMs, onChange, value]);
    var handleClear = function () {
        setLocalValue("");
        onChange("");
    };
    return ((0, jsx_runtime_1.jsx)(react_1.Input, { isClearable: true, className: className, placeholder: placeholder, startContent: (0, jsx_runtime_1.jsx)(SearchIcon, {}), value: localValue, onValueChange: setLocalValue, onClear: handleClear, size: "sm", variant: "bordered" }));
}
